import React from "react";

import Spinner from "@/common/components/loaders/Spinner";

interface PageLoaderProps {
  /**
   * Fill the entire viewport instead of just the parent container. Use for
   * top-level route-transition fallbacks that render outside the app shell,
   * where `h-full` would otherwise collapse.
   */
  fullScreen?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({ fullScreen = false }) => (
  <div
    className={`flex w-full items-center justify-center p-8 ${
      fullScreen ? "min-h-svh bg-background" : "h-full"
    }`}
  >
    <Spinner size="xl" />
  </div>
);

export default PageLoader;
